import { ReactElement } from 'react';

import { EmailAddress } from '@dreryk/email-address-common-api';

import { Accordion, StyledFlex } from '@dreryk/react-components';

import { StyledAccordionSectionContent } from '../HealthcareProviderPatientPortalPanel.styled';
import { settingsTranslationKeys } from '../../translations';

import { AppointmentRequestsSettingsFields } from './AppointmentRequestsSettingsForm/AppointmentRequestsSettingsFields';
import { AppointmentRequestsSettingsFormController } from './AppointmentRequestsSettingsForm/AppointmentRequestsSettingsForm.types';

const t = settingsTranslationKeys;

type HealthcareProviderSettingsSectionProps = Readonly<
   Pick<AppointmentRequestsSettingsFormController, 'register' | 'watch'> & {
      id: string;
      defaultAppointmentRequestsEmail: EmailAddress | null;
   }
>;

export const HealthcareProviderSettingsSection = (props: HealthcareProviderSettingsSectionProps): ReactElement => {
   return (
      <Accordion.Section id={props.id} testId={props.id} label={t.appointmentRequestsSettings}>
         <StyledAccordionSectionContent>
            <StyledFlex direction={'column'} gap={'12px'}>
               <AppointmentRequestsSettingsFields
                  register={props.register}
                  watch={props.watch}
                  defaultAppointmentRequestsEmail={props.defaultAppointmentRequestsEmail}
               />
            </StyledFlex>
         </StyledAccordionSectionContent>
      </Accordion.Section>
   );
};
